(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_workshop-archive"] && !Shopify.designMode) return;
  try {
    (function () {
    var SMOOTH = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';

    /**
     * Shopify wraps each theme block in its own <div class="shopify-block">,
     * so the Year sections are cousins rather than siblings. Move that
     * wrapper, not the section, to keep the customizer's block targeting
     * intact.
     */
    function hostOf(year) {
      return year.closest('.shopify-block') || year;
    }

    /**
     * Collect the Year blocks into a <tab-group-component> and build the
     * sticky mini-nav from the pill each one carries.
     */
    function assemble(parent, hosts) {
      // One year needs no nav.
      if (hosts.length < 2) return;

      // Hold this spot while the group is built off-document.
      var marker = document.createComment('workshop-archive-tabs');
      parent.insertBefore(marker, hosts[0]);

      // Built detached on purpose: <tab-group-component> bails out if it
      // initializes with no tabs, so it must first connect fully populated.
      var group = document.createElement('tab-group-component');
      group.className = 'workshop-archive';

      var bar = document.createElement('div');
      bar.className = 'workshop-archive__tabs';

      var nav = document.createElement('div');
      nav.className = 'workshop-archive__nav';
      bar.appendChild(nav);

      var list = document.createElement('div');
      list.className = 'workshop-archive__tablist';
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Archive years');

      // One pair of arrows serves the whole nav, so keep the first Year's
      // copy and drop the rest.
      var arrows = hosts[0].querySelector('template[data-archive-arrows]');
      var prev = null;
      var next = null;

      if (arrows) {
        var pair = arrows.content.cloneNode(true);
        prev = pair.querySelector('[data-archive-prev]');
        next = pair.querySelector('[data-archive-next]');
        if (prev) nav.appendChild(prev);
      }

      nav.appendChild(list);
      if (next) nav.appendChild(next);

      hosts.forEach(function (host) {
        var pill = host.querySelector('template[data-archive-tab]');
        if (pill) {
          list.appendChild(pill.content);
          pill.remove();
        }

        var spare = host.querySelector('template[data-archive-arrows]');
        if (spare) spare.remove();

        group.appendChild(host);
      });

      group.appendChild(bar);
      parent.replaceChild(group, marker);

      if (prev && next) carousel(list, prev, next);
      keepInView(group, list);
    }

    /**
     * Wire the arrows to the year strip and keep them in step with how far
     * it can still travel: an arrow is disabled the moment there is nothing
     * left that way.
     */
    function carousel(list, prev, next) {
      function limit() {
        return list.scrollWidth - list.clientWidth;
      }

      function sync() {
        var max = limit();
        // Sub-pixel widths mean scrollLeft rarely lands exactly on 0 or max.
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= max - 1;
      }

      function page(direction) {
        list.scrollBy({ left: direction * list.clientWidth, behavior: SMOOTH });
      }

      prev.addEventListener('click', function () {
        page(-1);
      });
      next.addEventListener('click', function () {
        page(1);
      });

      list.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      sync();
      list.__syncArrows = sync;
    }

    /**
     * Keep the reader oriented: pull a selected year that is scrolled out of
     * the strip back into it, and pull the archive itself back up when a
     * shorter year would otherwise leave the reader below the content.
     */
    function keepInView(group, list) {
      group.addEventListener('tab-group:change', function () {
        var active = list.querySelector('[data-hook="tab-button"].on');

        if (active) {
          var start = active.offsetLeft;
          var end = start + active.offsetWidth;

          if (start < list.scrollLeft) {
            list.scrollTo({ left: start - 8, behavior: SMOOTH });
          } else if (end > list.scrollLeft + list.clientWidth) {
            list.scrollTo({
              left: end - list.clientWidth + 8,
              behavior: SMOOTH,
            });
          }
        }

        if (list.__syncArrows) list.__syncArrows();

        if (group.getBoundingClientRect().top >= 0) return;
        group.scrollIntoView({ behavior: SMOOTH, block: 'start' });
      });
    }

    function init() {
      var years = Array.prototype.slice.call(
        document.querySelectorAll('[data-archive-year]')
      );
      if (years.length < 2) return;

      // Years from separate sections each get their own tab group.
      var groups = [];
      years.forEach(function (year) {
        var host = hostOf(year);
        var entry = groups.filter(function (g) {
          return g.parent === host.parentNode;
        })[0];

        if (!entry) {
          entry = { parent: host.parentNode, hosts: [] };
          groups.push(entry);
        }
        entry.hosts.push(host);
      });

      groups.forEach(function (entry) {
        assemble(entry.parent, entry.hosts);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
